// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "sidebarItem__wrapper-3lFPy";
var _5 = "sidebarItem-2F5Wa";
var _6 = "sidebarItem_selected-OgtOl";
var _7 = "sidebarItem__text-3BzOW";
var _8 = "sidebarItem__icon-1SHlk";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "sidebarItem__wrapper", _5 as "sidebarItem", _6 as "sidebarItem_selected", _7 as "sidebarItem__text", _8 as "sidebarItem__icon" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "sidebarItem__wrapper": _4, "sidebarItem": _5, "sidebarItem_selected": _6, "sidebarItem__text": _7, "sidebarItem__icon": _8 }
